'use strict';

var _ = require('lodash');
var EffectiveValueCalculatorService = function EffectiveValueCalculatorService() {
  function getProcessingChunkKey(item) {
    return item.classGroup + '-' + item.departureDate + '-' + item.significantPOS;
  }
  function calculate(modelGroups, userGroups) {
    var effectiveGroups = [];
    var adjustedGroupsIds = filterAdjustedGroupsIds(userGroups);
    var unadjustedModelGroups = filterUnadjustedModelGroups(modelGroups, adjustedGroupsIds);
    var totalModelShareOfUnadjustedGroups = calculateSumOfShares(unadjustedModelGroups);
    var modelGroupsValuesSum = _.sumBy(modelGroups, 'value');
    var numberOfClassGroupDepartureDays = _.chain(modelGroups).values().flatMap().map(getProcessingChunkKey).uniq().value().length;
    modelGroupsValuesSum = modelGroupsValuesSum > numberOfClassGroupDepartureDays ? numberOfClassGroupDepartureDays : modelGroupsValuesSum;
    var totalUserShare = calculateSumOfShares(userGroups);
    var shareLeftToRedistribute = totalModelShareOfUnadjustedGroups === 0 ? 0 : calculateShareToRedistributeBetweenUnadjustedGroups(totalUserShare, modelGroupsValuesSum);
    _.forEach(modelGroups, function (modelGroup) {
      var groupId = modelGroup.groupId;
      var effectiveShare = calculateEffectiveShareForOneGroup(groupId, adjustedGroupsIds, userGroups, totalModelShareOfUnadjustedGroups, shareLeftToRedistribute, totalUserShare, modelGroups, modelGroupsValuesSum);
      effectiveGroups.push({
        groupId: groupId,
        bucketId: modelGroup.bucketId,
        value: +effectiveShare.toFixed(6)
      });
    });
    return effectiveGroups;
  }
  function calculateAndGroupBy(modelGroups, userGroups) {
    var numberOfProcessingChunks = 0;
    var effectiveValuesGroupedByBucketId = _.chain(modelGroups).groupBy(getProcessingChunkKey).reduce(function (effectiveValues, processingChunk, processingChunkKey) {
      var groupedUserGroups = _.filter(userGroups, function (item) {
        return getProcessingChunkKey(item) === processingChunkKey;
      });
      numberOfProcessingChunks++;
      return _.concat(effectiveValues, calculate(processingChunk, groupedUserGroups));
    }, []).groupBy('bucketId').value();
    var modelGroupsValuesSum = _.sumBy(modelGroups, 'value');
    modelGroupsValuesSum = modelGroupsValuesSum > numberOfProcessingChunks ? numberOfProcessingChunks : modelGroupsValuesSum;
    return _.map(effectiveValuesGroupedByBucketId, function (value, key) {
      var sum = _.sumBy(value, 'value') / modelGroupsValuesSum;
      sum = sum > 1 ? 1 : sum;
      return {
        groupId: key,
        value: sum
      };
    });
  }
  function calculateEffectiveShareForOneGroup(groupId, adjustedGroupsIds, userGroups, totalModelShareOfUnadjustedGroups, shareLeftToRedistribute, totalUserShare, modelGroups, modelGroupsValuesSum) {
    var effectiveShare;
    var numberOfAdjustedGroups = modelGroups.length - adjustedGroupsIds.length;
    if (groupHasUserAdjustment(adjustedGroupsIds, groupId)) {
      var userShare = getShareForGroupId(userGroups, groupId);
      effectiveShare = calculateDirectlyAdjustedEffectiveShare(userShare, totalModelShareOfUnadjustedGroups, shareLeftToRedistribute, totalUserShare, modelGroupsValuesSum);
    } else {
      var modelShare = getShareForGroupId(modelGroups, groupId);
      effectiveShare = calculateNormalizedEffectiveShare(modelShare, totalModelShareOfUnadjustedGroups, shareLeftToRedistribute, totalUserShare, modelGroupsValuesSum, numberOfAdjustedGroups);
    }
    return effectiveShare;
  }
  function calculateDirectlyAdjustedEffectiveShare(userShare, totalModelShareOfUnadjustedGroups, shareLeftToRedistribute, totalUserShare, modelGroupsValuesSum) {
    if (totalUserShare === 0 && totalModelShareOfUnadjustedGroups === 0) {
      return 0;
    }
    return userShare / (totalUserShare + shareLeftToRedistribute) * modelGroupsValuesSum;
  }
  function calculateNormalizedEffectiveShare(modelShare, totalModelShareOfUnadjustedGroups, shareLeftToRedistribute, totalUserShare, modelGroupsValuesSum, numberOfAdjustedGroups) {
    if (totalModelShareOfUnadjustedGroups === 0) {
      if (totalUserShare === 0) {
        return modelGroupsValuesSum / numberOfAdjustedGroups;
      }
      return 0;
    }
    return modelShare / totalModelShareOfUnadjustedGroups * shareLeftToRedistribute;
  }
  function filterAdjustedGroupsIds(groups) {
    return _.chain(groups).filter(function (group) {
      return !_.isNil(group.value);
    }).map(function (group) {
      return group.groupId;
    }).value();
  }
  function filterUnadjustedModelGroups(modelGroups, adjustedGroupsIds) {
    return _.filter(modelGroups, function (group) {
      return !_.includes(adjustedGroupsIds, group.groupId);
    });
  }
  function calculateShareToRedistributeBetweenUnadjustedGroups(totalUserShare, modelGroupsValuesSum) {
    return totalUserShare >= modelGroupsValuesSum ? 0 : modelGroupsValuesSum - totalUserShare;
  }
  function getShareForGroupId(groups, groupId) {
    var group = _.find(groups, function (element) {
      return element.groupId === groupId;
    });
    return group.value ? group.value : 0;
  }
  function calculateSumOfShares(groups) {
    return _.sumBy(groups, 'value') || 0;
  }
  function groupHasUserAdjustment(adjustedGroupsIds, groupId) {
    return _.includes(adjustedGroupsIds, groupId);
  }
  return {
    calculate: calculate,
    calculateAndGroupBy: calculateAndGroupBy
  };
};
EffectiveValueCalculatorService.$inject = [];
module.exports = EffectiveValueCalculatorService;